var path = 'src/app/components/customer/common/customer-breadcrumbs.template.html';
var html = "<breadcrumb></breadcrumb>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;